
import {Vue, Component, Watch} from 'vue-property-decorator';
import goodSaleDialog from "@/views/business/business/goodSaleDialog.vue";
import {Util} from "@/common/util";
import GoodsSellAPIClass from "@/common/api/goodsSell";
import billPrint from "@/components/print.vue";
@Component({
  components:{
    billPrint,
    goodSaleDialog
  }
})
export default class componentsGoodsSale extends Vue {
  private keydownHandler: ((e: KeyboardEvent) => void) | null = null;
  private classApi: any = new GoodsSellAPIClass();
  private onShowGoodsSale(): void {
    this.$refs.goodSale.show('','')
  }
  private orderinfo: any = {};
  private selectgoodsList: any = [];
  private goodsprice: number = 0;
  private pay: boolean = false;
  private pay_type: any = [
    // {
    //   check: 4,
    //   name: "会员",
    //   icon: require("@/assets/dialog/huiyuan.png"),
    // },
    {
      check: 2,
      name: "微信或支付宝",
      icon: require("@/assets/dialog/weixin.png"),
    },
    {
      check: 6,
      name: "现金",
      icon: require("@/assets/dialog/xianjin.png"),
    },
    {
      check: 3,
      name: "线下收款码",
      icon: require("@/assets/dialog/shoukuanma.png"),
    },
    // {
    //   check: 1,
    //   name: "微信",
    //   icon: require("@/assets/dialog/icon／微信@2x.png"),
    // },
  ];
  private check: number = 2;
  private userinfo: any = {
    type: 0,
  };
  private msg: string = "";
  private phone: string = "";
  private isLoading:boolean = false
  private isPayLoading:boolean = false
  private scanCode: boolean = false;
  private getgoodsprice(): void {
    this.goodsprice = 0;
    for (let i of this.selectgoodsList) {
      this.goodsprice += i.num * i.price;
    }
  }
  private biz_type: number = 2;
  private code: string = "";
  private orderpay(print = false): void {
    // //1商品预支付 2商品扫码收款
    if(this.check === 2){
      this.biz_type = 2
      this.scanCodePay();
      return;
    }
    //现金支付或会员支付
    if (this.check === 3 || this.check === 6) {
      if(this.isPayLoading){
        return;
      }
      this.isPayLoading = true
      this.biz_type = 1
      this.classApi.payrequest(
          {
            order_id: this.orderinfo.id,
            pay_type: this.check,
            biz_type: this.biz_type,
            user_id: this.userinfo.id,
            // code: this.code,
            // is_vip_pay: this.is_vip_pay,
          },
          () => {
            Util.showToast("支付成功");
            this.$refs.goodSale.close()
            // if (print) {
            //   this.charge();
            // }
            this.code = "";
            this.userinfo.id = "";
            this.msg = "";
            this.phone = "";
            this.pay = false;
            this.scanCode = false;

            setTimeout(()=>{
              this.isPayLoading = false
            },300)
          },()=>{
            setTimeout(()=>{
              this.isPayLoading = false
            },300)
          }
      );
      return
    }
  }
  private payInfo: any = {};
  private chargebill: any = {};
  private good_list: any = [];
  private tableDataTreat: any = [];
  private charge(): void {

    this.classApi.charge(
        {
          merge_order_id: this.payInfo.merge_order_id,
        },
        (res: any) => {
          this.chargebill = res.data;
          this.good_list = res.data.good_list;
          this.tableDataTreat = [
            {
              name: "原始 - 台桌订单费用",
              money: res.data.order_price,
            },
            {
              name: "原始 - 商品订单费用",
              money: res.data.good_price,
            },
            {
              name: "原始 - 助教订单费用",
              money: res.data.assistant_price,
            },
            {
              name: "原始 - 总费用",
              money: res.data.total_price,
            },
            {
              name: "实际支付 - 台桌订单费用",
              money: res.data.actual_order_price,
            },
            {
              name: "实际支付 - 商品订单费用",
              money: res.data.actual_good_price,
            },
            {
              name: "实际支付 - 助教订单费用",
              money: res.data.actual_assistant_price,
            },
            {
              name: "实际支付 - 总费用",
              money: res.data.actual_total_price,
            },
          ];
          this.printDialog = true;
        }
    );
  }
  private goodsSuccess(obj:any):void{
    this.selectgoodsList = obj.selectgoodsList
    this.orderinfo = obj.orderinfo;
    this.getgoodsprice();
    this.pay = true;
    this.userinfo.id = "";
    this.msg = "";
    this.phone = "";
    this.isLoading = false
  }

  private payquery(): void {
    this.classApi.payquery(
        {
          order_id: this.orderinfo.id,
          biz_type: 2,
        },
        (res: any) => {
          if (this.buy_ok.includes(res.code)) {
            Util.showToast("支付成功");
            this.code = "";
            this.pay = false;
            this.scanCode = false;
            this.$refs.goodSale.close()
            clearInterval(this.timer);
          }
        }
    );
  }
  private changePayType(check: number): void {
    this.check = check;
    if (check == 1 || check == 2) {
      this.scanCodePay();
      console.log('check,biz_type',this.check,this.biz_type)
    }
  }
  private scanCodePay(): void {
    this.scanCode = true;
    this.focusInput()
    // this.getscanCode(2);
  }
  private auth_code: string = "";
  private buy_ok = [200, 400220, 400213];
  private buy_two = [400217, 400218, 400214];
  private timer: any = null;
  private printDialog: boolean = false;
  private isProcessingPay = false; // 添加节流状态标记
  private payrequest(auth_code:string|number=''): void {
    if (this.isProcessingPay) {
      console.log('支付请求已节流，跳过重复调用');
      return;
    }
    // 设置处理中状态
    this.isProcessingPay = true;
    this.classApi.payrequest(
        {
          order_id: this.orderinfo.id,
          pay_type: this.check,
          biz_type: this.check===2 ? 2 :1 ,
          auth_code: auth_code,
          user_id: this.userinfo.id,
          // code: this.code,
          // is_vip_pay: this.is_vip_pay,
        },
        (res: any) => {
          if (this.buy_ok.includes(res.code)) {
            Util.showToast("支付成功");
            // this.renewal = false;
            // this.show_table = false;
            this.check = 4;
            this.code = "";
            (this.auth_code = ""), (this.pay = false);
            this.scanCode = false;
            this.$refs.goodSale.close()
          } else if (this.buy_two.includes(res.code)) {
            if (res.code == 400217) {
              Util.showToast("需要用户输入支付密码");
              this.timer = window.setInterval(() => {
                this.payquery();
              }, 8000);
            } else if (res.code == 400218) {
              Util.showToast("付款码错误，请刷新二维码重试");
              this.timer = setInterval(() => {
                this.payquery();
              }, 8000);
            } else if (res.code == 400214) {
              Util.showToast("支付失败，余额不足");
              this.timer = setInterval(() => {
                this.payquery();
              }, 8000);
            }
          }
          // 重置节流状态
          this.isProcessingPay = false;
        },
        () => {
          if (this.timer == null) {
            this.timer = setInterval(() => {
              this.payquery();
            }, 5000);
          }
        }
    );
    setTimeout(() => {
      this.isProcessingPay = false;
      console.log('支付请求超时重置');
    }, 3000);
  }

  private selectgoods: any = new Set();
  private selectgood(row: any): void {
    row.num = 1;
    if (this.selectgoods.size > 0) {
      this.selectgoods.forEach((item: any) => {
        if (item.id != row.id) {
          this.selectgoods.add(row);
        }
      });
    } else {
      this.selectgoods.add(row);
    }

    // console.log(this.selectgoods.has(row))
    // if (this.selectgoods.has(row)) {
    //   console.log(this.selecgoodspricetgoods);
    // } else {
    //   this.selectgoods.add(row);
    //   console.log(this.selectgoods);
    // }
    this.selectgoodsList = [...this.selectgoods];
    this.getgoodsprice();
  }
  beforeDestroy() {
    console.log('组件销毁',)
    this.removeKeydownListener(); // 组件销毁时移除监听
  }
  private scanTimer: number | null = null;
  private isScanCodePrint:boolean = false
  private scanCodeInputValue:string = ''
  private focusInput():void {
    this.$nextTick(() => {
      // 确保 DOM 更新完成后再聚焦
      if (this.$refs.scanCodeInputRef) {
        this.$refs.scanCodeInputRef.focus()
        this.scanCodeInputValue = ''; // 清空输入框
      }
    });
  }
  private handleScanCodeInputBlur():void{
    console.log('失去焦点')
    setTimeout(() => {
      this.focusInput();
    }, 10);
  }
  // 监听输入值变化（备选方案）
  @Watch('scanCodeInputValue')
  onScanCodeValueChange(newVal: string) {
    // 清除已有定时器
    if (this.scanTimer) {
      clearTimeout(this.scanTimer);
    }

    // 设置新定时器：100ms内无新输入视为扫码完成
    this.scanTimer = window.setTimeout(() => {
      if (newVal&&newVal.length>=8) {
        this.processScanCode(newVal);
      }
    }, 100);
  }


  // 处理扫码结果
  private processScanCode(code: string) {
    // 清除定时器
    if (this.scanTimer) {
      clearTimeout(this.scanTimer);
      this.scanTimer = null;
    }

    // 执行支付
    this.payrequest(code);

    // 清空输入框并保持聚焦
    this.scanCodeInputValue = '';
    this.$refs.scanCodeInputRef.focus();
  }
  private removeKeydownListener() {
    if (this.keydownHandler) {
      document.removeEventListener('keydown', this.keydownHandler);
      this.keydownHandler = null;
    }
  }


  @Watch("scanCode")
  private changescanCode(): void {
    if (!this.scanCode) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

}
